export default function isFirstLastName(values, value) {
  if (value?.length) {
    const parts = value.trim().split(/ +/);
    return parts.length > 1;
  }
  return true;
}
